export default {
  RECURRING: 'RECURRING',
  TOPUP: 'TOPUP'
};